// extracted by mini-css-extract-plugin
export default {"notFound":"NotFound_notFound__zVVEa","redirUrl":"NotFound_redirUrl__piq0a"};